import { observer } from 'mobx-react-lite';
import React from 'react';
import { withDefaultProps } from 'react-default-props-context';
import { ExplanationT } from 'src/api/types/ExplanationT';
import { ForwardArrowIcon } from 'src/frames/icons/ForwardArrowIcon';
import { cn } from 'src/frames/utils/cn';
import './ExplanationListViewItem.scss';

export type PropsT = {
  label: string;
  explanation: ExplanationT;
  explanationPageIdx: number;
  className?: any;
};

type DefaultPropsT = {
  goToExplanationPage: (idx: number) => void;
};

export const ExplanationListViewItem: React.FC<PropsT> = observer(
  withDefaultProps<PropsT, DefaultPropsT>((props: PropsT & DefaultPropsT) => {
    return (
      <div
        className={cn(
          'ExplanationListViewItem',
          'flex flex-row justify-between',
          'px-4',
          props.className
        )}
        onClick={() => props.goToExplanationPage(props.explanationPageIdx)}
      >
        {props.label}
        <ForwardArrowIcon />
      </div>
    );
  })
);
